// Clear the preferences when user logout
export const clearPreferences = async () => {
  try {
    // Remove preferences from the secure storage
    return localStorage.removeItem("display.max_rows")
  } catch (error) {
    console.error("Failed to delete preferences: ", error)
    return null
  }
}
